import axios from "axios";

export default axios.create({
  baseURL: "https://backgarage-005855bd43c7.herokuapp.com/",
});
